"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessModalWidget = void 0;
var React = require("react");
var react_html_parser_1 = require("react-html-parser");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var StorageSuccessModal_1 = require("../components/modals/StorageSuccessModal");
var SuccessModalWidget = exports.SuccessModalWidget = /** @class */ (function (_super) {
    __extends(SuccessModalWidget, _super);
    function SuccessModalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () { return (React.createElement(StorageSuccessModal_1.StorageSuccessModal, { title: _this.renderHtml(_this.title), explanationWording: _this.renderHtml(_this.bodyHtml), onClose: _this.handleClose })); };
        _this.renderHtml = function (htmlText) {
            return (0, react_html_parser_1.default)(_this.renderTemplate(htmlText, true), {
                transform: function (node) {
                    if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                        return null;
                    }
                    return;
                }
            });
        };
        _this.renderTemplate = function (template, escapeFields) {
            return journey_services_1.ExpressionEvaluator.renderTemplate(template, _this.props.interaction, escapeFields);
        };
        _this.handleClose = function () {
            _this.executeEvent("blur");
        };
        _this.title = _this.getSetting("title");
        if (!_this.title) {
            throw new Error("Widget ".concat(_this.props.question.type, " (").concat(_this.props.question.name, ") missing 'title' setting"));
        }
        _this.bodyHtml = _this.getSetting("bodyHtml");
        if (!_this.bodyHtml) {
            throw new Error("Widget ".concat(_this.props.question.type, " (").concat(_this.props.question.name, ") missing 'bodyHtml' setting"));
        }
        _this.state = {
            isOpen: true
        };
        return _this;
    }
    SuccessModalWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "title", type: journey_model_1.TypeDescriptions.String },
            { name: "bodyHtml", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], SuccessModalWidget);
    return SuccessModalWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=SuccessModalWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/SuccessModalWidget.js
// module id = 3653
// module chunks = 0